import { render, staticRenderFns } from "./installmentsHistory.vue?vue&type=template&id=6d9c6144&"
import script from "./installmentsHistory.vue?vue&type=script&lang=js&"
export * from "./installmentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports